import requestStatuses from '@clearscore/constants.request-statuses';

import normaliseResults from './lib/normalise-results';
import mergeFetchStatus from './lib/merge-fetch-status';
import mergeResultsRequestData from './lib/merge-results-request-data';
import {
    PRODUCTS_RESULTS_FETCH,
    PRODUCTS_RESULTS_FETCH_SUCCESS,
    PRODUCTS_RESULTS_FETCH_ERROR,
    PRODUCTS_DETAILS_FETCH,
    PRODUCTS_DETAILS_FETCH_SUCCESS,
    PRODUCTS_DETAILS_FETCH_ERROR,
    STORE_RESULTS_REQUEST_DATA,
    PRODUCT_FILTERS_FETCH,
    PRODUCT_FILTERS_FETCH_SUCCESS,
    PRODUCT_FILTERS_FETCH_ERROR,
    PRODUCT_SORTING_FETCH,
    PRODUCT_SORTING_FETCH_SUCCESS,
    PRODUCT_SORTING_FETCH_ERROR,
} from '../types';

const initialState = {
    lastFetched: {},
    fetchStatuses: {},
    resultsRequestData: {},
};

const products = (state = initialState, action) => {
    const { type, payload, requestMeta, statusCode } = action;

    switch (type) {
        case PRODUCTS_DETAILS_FETCH:
        case PRODUCTS_RESULTS_FETCH:
        case PRODUCT_FILTERS_FETCH:
        case PRODUCT_SORTING_FETCH:
            return {
                ...state,
                ...mergeFetchStatus(requestStatuses.PENDING, payload.request.meta, state),
            };
        case PRODUCTS_DETAILS_FETCH_SUCCESS:
            return {
                ...state,
                ...mergeFetchStatus(requestStatuses.SUCCESS, requestMeta, state, statusCode),
            };
        case PRODUCT_FILTERS_FETCH_SUCCESS:
        case PRODUCTS_RESULTS_FETCH_SUCCESS:
        case PRODUCT_SORTING_FETCH_SUCCESS:
            return {
                ...state,
                ...normaliseResults(payload),
                ...mergeFetchStatus(requestStatuses.SUCCESS, requestMeta, state, statusCode),
            };
        case PRODUCTS_DETAILS_FETCH_ERROR:
        case PRODUCTS_RESULTS_FETCH_ERROR:
        case PRODUCT_FILTERS_FETCH_ERROR:
        case PRODUCT_SORTING_FETCH_ERROR:
            return {
                ...state,
                ...mergeFetchStatus(requestStatuses.ERROR, requestMeta, state, statusCode),
            };
        case STORE_RESULTS_REQUEST_DATA:
            return {
                ...state,
                ...mergeResultsRequestData(state.resultsRequestData, payload),
            };
        default:
            return state;
    }
};

export default products;
